import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import TopMenu from './components/TopMenu'
import MobileMenu from './components/MobileMenu'
import ProfileDropdown from './components/ProfileDropdown'
import ThemeModeToggle from './components/ThemeModeToggle'
import LanguageSwitcher from './components/LanguageSwitcher'
import { Container } from 'react-bootstrap'
import IconifyIcon from './../../../components/wrapper/IconifyIcon'
import Notifications from './components/Notifications'
import LoginButton from './components/LoginButton'
import TelegramSocialLinks from './components/TelegramSocialLinks'

const Page = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const logoSrc = `${process.env.PUBLIC_URL}/filter_market_logo_transparente.png`

  return (
    <>
      <header className="app-topbar px-3 px-md-4">
        <div className="d-flex align-items-center justify-content-between w-100">

          {/* Mobile Hamburger - Left on Mobile */}
          <div className="d-lg-none d-flex align-items-center me-3" onClick={() => setShowMobileMenu(true)}>
            <IconifyIcon icon="mdi:menu" width="28" height="28" className="text-white cursor-pointer" />
          </div>

          <div className="d-flex align-items-center gap-4 flex-grow-1">
            <Link to="/oracle" className="topbar-logo" aria-label="Filter Market Oráculo">
              <img src={logoSrc} alt="Filter Market logo" className="topbar-logo-image" />
            </Link>
            <TopMenu />
            {/* Mobile Label if needed or Logo could go here */}
          </div>

          <div className="d-flex align-items-center gap-3">
            <TelegramSocialLinks />
            <LanguageSwitcher />
            <LoginButton />
            {/* Add more icons here if needed like Notifications */}
          </div>
        </div>
      </header>

      <MobileMenu show={showMobileMenu} onHide={() => setShowMobileMenu(false)} />
    </>
  )
}

export default Page
